/** @jsxImportSource @emotion/react */
import { memo } from "react";

// CSS読み込み
import {
  optionContainer,
  optionLabel,
  optionLabelRequired,
  optionLabelAny,
} from "assets/css/stylesCss";

/**
 * 任意・ヒントアイコン付きラベルコンポーネント
 * @param {String} children 子要素
 * @param {Boolean} required true : 必須
 *                           false: 任意
 */
const LabelWithOptionIcon = memo(({ required, children }) => {

  return (
    <label css={optionContainer}>
      <span css={optionLabel}>{children}</span>
      <span>
        {/** 必須・任意ラベル */}
        {required
          ? <span css={optionLabelRequired}>必須</span>
          : <span css={optionLabelAny}>任意</span>
        }
      </span>
    </label>
  );
});

export default LabelWithOptionIcon;